import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconMicOff — 麦克风关：麦克风开造型 + 斜线，表示静音 / 禁用拾音 */
export default function IconMicOff(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path d="M8 1.93a2.27 2.27 0 0 1 2.27 2.27v3.73a2.27 2.27 0 1 1-4.53 0V4.2A2.27 2.27 0 0 1 8 1.93Z" />
      <path d="M12.53 7.47a4.53 4.53 0 0 1-9.07 0" />
      <path d="M8 12v2" />
      <path d="M5.8 14h4.4" />
      <path d="M2.53 2.53l10.93 10.93" />
    </BizIconSvg>
  );
}
